import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { Form, FormRenderProps } from 'react-final-form';

import { Typography, Button } from '@occc/ui-design-system';
import { LocationMultipleSelectField } from '@occc-app/routes/Location/components/LocationSelect/LocationMultipleSelectField';
import { LocationFragment } from '@occc/graphql';

import { LocationsFilterFormValues } from './types';

type LocationsFilterFormProps = {
  locations: LocationFragment[];
  onFilterFormSubmit: (values: LocationsFilterFormValues) => void;
  onFilterFormReset: () => void;
};

export const LocationsFilterForm = ({
  locations,
  onFilterFormReset,
  onFilterFormSubmit,
}: LocationsFilterFormProps) => {
  const initialValues = useMemo(() => {
    return { locations };
  }, [locations]);

  const renderFilterForm: FormRenderProps<LocationsFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form }: FormRenderProps<LocationsFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onFilterFormReset();
      };

      return (
        <form onSubmit={handleSubmit}>
          <Box px={4} pt={4}>
            <Typography variant='body1' mb={3}>
              Filter Locations
            </Typography>

            <LocationMultipleSelectField
              inputProps={{
                margin: 'none',
              }}
              name='locations'
              label='Show Specific Locations'
            />
          </Box>

          <Box display='flex' justifyContent='flex-end' px={3} py={2}>
            <Button size='small' onClick={reset} sx={{ mr: 2 }}>
              reset
            </Button>
            <Button variant='contained' type='submit' size='small' color='primary'>
              apply
            </Button>
          </Box>
        </form>
      );
    },
    [onFilterFormReset],
  );

  return (
    <Form<LocationsFilterFormValues>
      render={renderFilterForm}
      onSubmit={onFilterFormSubmit}
      initialValues={initialValues}
    />
  );
};
